import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';

@Component({
    selector: 'se-import-icon-renderer',
    templateUrl: './import-icon-renderer.component.html',
    styleUrls: ['./import-icon-renderer.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ImportIconRendererComponent implements ICellRendererAngularComp {
    private data!: Partial<Record<string, unknown>>;
    private callbackImport!: (data: Partial<Record<string, unknown>>) => void;

    refresh(params: any): boolean {
        this.updateParams(params);

        return true;
    }

    agInit(params: any): void {
        this.updateParams(params);
    }

    invokeImportMethod($event: MouseEvent) {
        $event.stopPropagation();
        this.callbackImport(this.data);
    }

    private updateParams(params: any) {
        this.data = params.data;

        this.callbackImport = params.context.callbackImport;
    }
}
